var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#407EDB",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30.0001H19.25C19.6642 30.0001 20 29.6643 20 29.25C20 28.8358 19.6642 28.5 19.25 28.5H10.5C9.94772 28.5 9.5 28.0523 9.5 27.5V10.5C9.5 9.94771 9.94772 9.5 10.5 9.5H27.5C28.0523 9.5 28.5 9.94772 28.5 10.5V19.75C28.5 20.1642 28.8358 20.5 29.25 20.5C29.6642 20.5 30 20.1642 30 19.75V10C30 8.89543 29.1046 8 28 8H10C8.89543 8 8 8.89543 8 10V28.0001C8 29.1046 8.89543 30.0001 10 30.0001Z",
    fill: "#407EDB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 0.5,
    fill: "#407EDB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 5.25,
    stroke: "#407EDB",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.5002C11 10.7764 10.7762 11.0002 10.4999 11.0002C10.2238 11.0002 10 10.7764 10 10.5002C10 10.2241 10.2238 10.0002 10.4999 10.0002C10.7762 10.0002 11 10.2241 11 10.5002Z",
    fill: "#407EDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 10.5002C13.0002 10.7764 12.7762 11.0002 12.5001 11.0002C12.224 11.0002 12 10.7764 12 10.5002C12 10.2241 12.224 10.0002 12.5001 10.0002C12.7762 10.0002 13.0002 10.2241 13.0002 10.5002Z",
    fill: "#407EDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5002C15 10.7764 14.7762 11.0002 14.5001 11.0002C14.2238 11.0002 14 10.7764 14 10.5002C14 10.2241 14.2238 10.0002 14.5001 10.0002C14.7762 10.0002 15 10.2241 15 10.5002Z",
    fill: "#407EDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4238 22.166C26.3975 22.141 26.3637 22.1295 26.335 22.11C26.3002 22.0872 26.2701 22.0597 26.2305 22.0438C26.0828 21.9854 25.9172 21.9854 25.7695 22.0438C25.7034 22.07 25.6447 22.1088 25.5931 22.1557C25.5883 22.1603 25.581 22.1614 25.5762 22.1672L23.1756 24.4532C22.9415 24.6761 22.9415 25.0383 23.1756 25.2612C23.4097 25.4841 23.79 25.4841 24.0241 25.2612L25.3988 23.9501V29.4285C25.3988 29.744 25.6677 30 25.999 30C26.3304 30 26.5992 29.744 26.5992 29.4285V23.9501L27.9746 25.261C28.0922 25.3718 28.2459 25.4279 28.3994 25.4279C28.5532 25.4279 28.7067 25.3718 28.8244 25.2599C29.0585 25.0369 29.0585 24.6747 28.8244 24.4518L26.4238 22.166Z",
    fill: "#407EDB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 20,
    height: 1,
    fill: "#407EDB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSample);
export default __webpack_public_path__ + "static/media/sample.eb7efbae37bf72f3d10e1f9968dc81ab.svg";
export { ForwardRef as ReactComponent };